export default {
  loading: false,
  budget: [],
};
